/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubstituteApplyInfoViewModel { 
    substituteApplyId?: number;
    principalSubstitute?: string;
    principalSubstituteName?: string;
    principalSubstituteDeptName?: string;
    todoItemSubstitute?: string;
    todoItemSubstituteName?: string;
    todoItemSubstituteDeptName?: string;
    applicant?: string;
    applicantName?: string;
    substituteFrom?: Date;
    substituteTo?: Date;
    statusCode?: string;
    systemName?: string;
    systemFunctionName?: string;
    sourceCaseDeptName?: string;
    rank?: number;
    substitute?: string;
    substituteName?: string;
}